"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectUtils = void 0;
var ObjectUtils = /** @class */ (function () {
    function ObjectUtils() {
    }
    /**
     * @param {T} data - The data to copy.
     * @returns {T} - The copied data.
     */
    ObjectUtils.copyDeep = function (data) {
        // @ts-ignore
        var node;
        if (Array.isArray(data)) {
            node = data.length > 0 ? data.slice(0) : [];
            node.forEach(function (e, i) {
                if ((typeof e === 'object' && e !== {}) ||
                    (Array.isArray(e) && e.length > 0)) {
                    node[i] = ObjectUtils.copyDeep(e);
                }
            });
        }
        else if (typeof data === 'object') {
            node = Object.assign({}, data);
            Object.keys(node).forEach(function (key) {
                if (
                // @ts-ignore
                (typeof node[key] === 'object' && node[key] !== {}) ||
                    // @ts-ignore
                    (Array.isArray(node[key]) && node[key].length > 0)) {
                    // @ts-ignore
                    node[key] = ObjectUtils.copyDeep(node[key]);
                }
            });
        }
        else {
            node = data;
        }
        // @ts-ignore
        return node;
    };
    /**
     * @param {T} item - The item to check.
     * @returns {T} - Whether the item is an object.
     */
    ObjectUtils.isObject = function (item) {
        return item && typeof item === 'object' && !Array.isArray(item);
    };
    /**
     * @param {T} target - The target object.
     * @param {T} sources - The objects to merge.
     * @returns {T} - The merged object.
     */
    ObjectUtils.mergeDeep = function (target, sources, extra) {
        var _a, _b;
        if (!sources.length) {
            return target;
        }
        var explicitMerge = (extra ? extra.explicitMerge : null) || [];
        var source = sources.shift();
        if (ObjectUtils.isObject(target) && ObjectUtils.isObject(source)) {
            for (var key in source) {
                if (ObjectUtils.isObject(source[key])) {
                    if (!target[key])
                        Object.assign(target, (_a = {}, _a[key] = {}, _a));
                    if (explicitMerge.indexOf(key) !== -1) {
                        target[key] = ObjectUtils.explicitFlatMerge(
                        // @ts-ignore
                        target[key], source[key]);
                    }
                    else {
                        // @ts-ignore
                        ObjectUtils.mergeDeep(target[key], [source[key]], extra);
                    }
                }
                else {
                    Object.assign(target, (_b = {}, _b[key] = source[key], _b));
                }
            }
        }
        return ObjectUtils.mergeDeep(target, sources, extra);
    };
    ObjectUtils.mergeDefaults = function (source, defaults, extra) {
        return ObjectUtils.mergeDeep({}, [defaults, source], extra);
    };
    /**
     * source properties will override all equivalent properties in target. null or empty objects properties in source
     * will cause the removal of these properties in target.
     * all other data will be merged
     * @param initialObject
     * @param source
     */
    ObjectUtils.explicitFlatMerge = function (initialObject, source) {
        var result = __assign({}, initialObject);
        Object.keys(source).forEach(function (key) {
            // @ts-ignore
            if (source[key] === null || Object.keys(source[key]).length === 0) {
                delete result[key];
            }
            else {
                // @ts-ignore
                // https://github.com/microsoft/TypeScript/issues/31661
                result[key] = source[key];
            }
        });
        return result;
    };
    ObjectUtils.get = function (obj, path, defaultValue) {
        function stringToPath(path) {
            // @ts-ignore
            var output = [];
            // Split to an array with dot notation
            path.split('.').forEach(function (item) {
                // Split to an array with bracket notation
                item.split(/\[([^}]+)\]/g).forEach(function (key) {
                    // Push to the new array
                    if (key.length > 0) {
                        output.push(key);
                    }
                });
            });
            // @ts-ignore
            return output;
        }
        // Get the path as an array
        var pathArray = stringToPath(path);
        var current = obj;
        // For each item in the path, dig into the object
        for (var i = 0; i < pathArray.length; i++) {
            // If the item isn't found, return the default (or null)
            if (!current[pathArray[i]])
                return defaultValue;
            // Otherwise, update the current value
            current = current[pathArray[i]];
        }
        return current;
    };
    return ObjectUtils;
}());
exports.ObjectUtils = ObjectUtils;
//# sourceMappingURL=object-utils.js.map